import { useContext } from 'react';
import { SessionContext } from 'contexts/session';
import { AccountPlanAddon } from 'contexts/accounts/types';
import { CONTENT_TYPES } from 'constants/playlists';
import { ADDON_SKILL_DIVE } from 'constants/plans_config';

// The plan's Skill Dive add-on can carry either code, so match those as well as the name.
const SKILL_DIVE_ADDON_CODES = new Set(['skill-dive', ADDON_SKILL_DIVE]);

export interface AccountWithPlanAddons {
  id?: string;
  account_addons?: { plan_addons?: AccountPlanAddon[] } | null;
}

// Whether to offer "Learn more": the plan offers Skill Dive and the account hasn't bought it.
// An account that owns Skill Dive, even with every seat committed, never gets the call to action.
const useCanGetSkillDive = (account?: AccountWithPlanAddons | null): boolean => {
  const sessionAccountDetails = useContext(SessionContext)?.accounts;
  // Most callers only have the `/me` account summary, which has no `plan_addons`; the session's
  // full account response carries them for the same account.
  const planAddons =
    account?.account_addons?.plan_addons ??
    (sessionAccountDetails && sessionAccountDetails.id === account?.id
      ? sessionAccountDetails.account_addons?.plan_addons
      : undefined);
  return Boolean(
    planAddons?.some(
      (addon) =>
        (SKILL_DIVE_ADDON_CODES.has(addon.code) || addon.name === CONTENT_TYPES.SKILL_DIVE) &&
        !addon.purchased
    )
  );
};

export default useCanGetSkillDive;
